<template>
  <v-card v-if="$isVihkoSeuranta" :loading="loading">
    <v-list-item>
      <v-list-item-content>
        <div class="text-overline mb-1">Leirikosken vihko</div>
        <v-list-item-subtitle class="text-wrap">
          Kiinteistöpäivystäjien neljä uusinta merkintää
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-avatar>
        <v-icon large>mdi mdi-notebook-outline</v-icon>
      </v-list-item-avatar>
    </v-list-item>
    <v-divider />
    <v-card-text>
      <v-alert v-if="previousWeekMissing" dense text type="error">
        Viikolta {{ previousWeek }} puuttuu merkintä.
      </v-alert>
      <v-alert v-if="currentWeekMissing" dense text type="warning">
        Kuluvalta viikolta {{ currentWeek }} ei ole vielä merkintää.
      </v-alert>

      <div v-if="!loading && vihot.length === 0" class="text-caption">
        Ei merkintöjä.
      </div>

      <v-list dense>
        <v-list-item
          v-for="vihko in vihot"
          :key="vihko.id"
          @click="openVihko(vihko)"
        >
          <v-list-item-content>
            <v-list-item-title>
              Viikko {{ $formatWeek(vihko.viikko) }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-wrap">
              {{ vihko.createdBy ? vihko.createdBy.user : "" }}
              <span v-if="vihko.siisteystarkastusHuomiot">
                — {{ vihko.siisteystarkastusHuomiot }}
              </span>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action class="flex-row align-center">
            <v-chip v-if="checklistCount(vihko)" small>
              {{ checklistDone(vihko) }} / {{ checklistCount(vihko) }}
            </v-chip>
            <v-chip
              v-if="checklistStatusCount(vihko, 1)"
              class="ml-1"
              color="orange"
              dark
              small
              title="Huomioita"
            >
              <v-icon left small>mdi mdi-exclamation-thick</v-icon>
              {{ checklistStatusCount(vihko, 1) }}
            </v-chip>
            <v-chip
              v-if="checklistStatusCount(vihko, 0)"
              class="ml-1"
              color="red"
              dark
              small
              title="Vikoja"
            >
              <v-icon left small>mdi mdi-alert</v-icon>
              {{ checklistStatusCount(vihko, 0) }}
            </v-chip>
            <v-icon class="ml-2">mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        text
        @click="$router.push({ path: '/leirikoski', query: { tab: 'vihko' } })"
      >
        Kaikki merkinnät
        <v-icon right>mdi-arrow-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { firestore as db } from "@/plugins/firebase.app";

export default {
  name: "LeirikoskiVihkoInfo",
  data: () => ({
    loading: false,
    vihot: [],
    weeksWithEntries: [],
  }),
  computed: {
    currentWeek() {
      return dayjs().format("WW/GGGG");
    },
    previousWeek() {
      return dayjs().add(-1, "week").format("WW/GGGG");
    },
    currentWeekMissing() {
      return !this.loading && !this.weeksWithEntries.includes(this.currentWeek);
    },
    previousWeekMissing() {
      return (
        !this.loading && !this.weeksWithEntries.includes(this.previousWeek)
      );
    },
  },
  created() {
    if (this.$isVihkoSeuranta) this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const snapshot = await getDocs(
          query(
            collection(db, "kiinteistopaivystaja_vihko"),
            where("deleted", "==", false),
            orderBy("viikko", "desc"),
            limit(20),
          ),
        );
        const vihot = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        this.weeksWithEntries = vihot.map((v) =>
          dayjs(v.viikko).format("WW/GGGG"),
        );
        this.vihot = vihot.slice(0, 4);
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
    checklistItems(vihko) {
      return (vihko?.siisteystarkastus || []).filter((i) => i.type !== "title");
    },
    checklistCount(vihko) {
      return this.checklistItems(vihko).length;
    },
    checklistDone(vihko) {
      return this.checklistItems(vihko).filter(
        (i) => i.done === 2 || i.done === 1 || i.done === 0,
      ).length;
    },
    checklistStatusCount(vihko, status) {
      return this.checklistItems(vihko).filter((i) => i.done === status).length;
    },
    openVihko(vihko) {
      this.$router.push({
        name: "LeirikoskiVihkoEdit",
        params: { id: vihko.id },
      });
    },
  },
};
</script>
